import React, { Component } from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import PruneIcon from '../../images/pruningMenuIcon2.svg';
import PruneIconRed from '../../images/pruningMenuIcon1.svg';


class PruningMenu extends Component {

    shouldComponentUpdate(nextProps, nextState) {
        if(!this.compareLists(this.props.pruningList, nextProps.pruningList) 
            || this.state !== nextState){
            return true;
        }
        else{
            return false; 
        }
    }

    compareLists = (list1, list2) => {
        ////NOTE: deep compare is needed
        if(list1.length !== list2.length){
            return false;
        }
        return true;
    }

    render() {

        return (
            <span>
                <List>
                    {this.props.pruningList.map((pruning, index) =>
                        <ListItem key={index}>
                            <ListItemText
                                primary={index + 1 + '. ' + pruning.ohl}
                                secondary={'Span: ' + pruning.span + '    Height: ' + pruning.height }
                            />
                            <span style={{ marginLeft: '5px', marginRight: '5px', cursor: 'pointer' }} >
                                <img
                                    src={pruning.isUrgent ? PruneIconRed : PruneIcon}
                                    title={'Show prune'}
                                    style={{ width: '20px !important', height: '20px' }}
                                    alt='Prune'
                                    onClick={() => this.props.onPruningClick(pruning)} />
                            </span>
                        </ListItem>
                    )}
                </List>
            </span>
        )
    }
}





export default PruningMenu;